import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';

const getAccordionStyles = (disabled) => ({
  background: disabled ? '#ebebeb' : 'white',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.14)',
  borderRadius: '20px',
  padding: '32px 48px',
  color: disabled ? '#959595' : 'initial',
  border: 'none',
  overflow: 'hidden',
});

function AccordionCard({ title, form, disabled, defaultExpanded = false }) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleAccordionChange = () => {
    setIsExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <Accordion
      expanded={isExpanded}
      onChange={handleAccordionChange}
      square={false}
      style={getAccordionStyles(disabled)}
    >
      <AccordionSummary
        expandIcon={
          <span
            style={{
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              color: '#000',
            }}
          >
            <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
          </span>
        }
        style={{
          padding: '0px',
          border: 'none',
          boxShadow: 'none',
          outline: 'none',
          background: 'transparent',
        }}
        aria-controls='panel1-content'
        id='panel1-header'
      >
        <Typography
          component='span'
          style={{ fontWeight: 600, fontSize: '21px' }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{form}</AccordionDetails>
    </Accordion>
  );
}

export default AccordionCard;
